import SuperFetch from 'library/helpers/superFetch';
import { put, takeLatest } from 'redux-saga/effects';
import { settingsActions } from 'reduxStore/settings/slice';
import { defaultSettingsActions } from './slice';

// ✅ Determine query params based on environment
const queryParams = process.env.NODE_ENV === 'production' ? { isInternal: false } : {};

export function* loadOrgDefaultSettings() {
	try {
		const defaultSettings = yield SuperFetch.get('/settings/defaultSettings', {}, queryParams).then((res) => {
			if (res.statusCode === 200) return res.data;
			else throw new Error(`DEFAULT SETTINGS ORGANIZATION: ${res.error[0]}`);
		});

		yield put(defaultSettingsActions.loadOrgDefaultSettingsSuccess(defaultSettings));
	} catch (error) {
		yield put(defaultSettingsActions.loadOrgDefaultSettingsError(error.message));
	}
}

export function* loadPersonDefaultSettings() {
	try {
		const defaultSettings = yield SuperFetch.get('/settings/people/defaultSettings', {}, queryParams).then(
			(res) => {
				if (res.statusCode === 200) return res.data;
				else throw new Error(`DEFAULT SETTING PERSON: ${res.error[0]}`);
			}
		);

		yield put(defaultSettingsActions.loadPersonDefaultSettingsSuccess(defaultSettings));
	} catch (error) {
		yield put(defaultSettingsActions.loadPersonDefaultSettingsError(error.message));
	}
}

export function* loadGroupSettingsSaga() {
	try {
		const defaultGroups = yield SuperFetch.get('/settings/group', {}, queryParams).then((res) => {
			if (res.statusCode === 200) return res.data;
			else throw new Error(`DEFAULT SETTING GROUP: ${res.error[0]}`);
		});

		yield put(defaultSettingsActions.loadGroupSettingsSuccess(defaultGroups));
	} catch (error) {
		yield put(defaultSettingsActions.loadGroupSettingsError(error.message));
	}
}

export function* loadOrgDefaultSettingsSuccess() {
	// once the default settings are loaded, we can load the org settings
	yield put(settingsActions.loadOrgSettings());
}

export function* loadPersonDefaultSettingsSuccess() {
	// once the default settings are loaded, we can load the person settings
	yield put(settingsActions.loadPersonSettings());
}

// ? No need to put out the actions for the groups as settings Group are the same across both default Settings and settings

// The main export for the saga
export default function* settingsSagas() {
	yield takeLatest(defaultSettingsActions.loadOrgDefaultSettings, loadOrgDefaultSettings);
	yield takeLatest(defaultSettingsActions.loadPersonDefaultSettings, loadPersonDefaultSettings);
	yield takeLatest(defaultSettingsActions.loadOrgDefaultSettingsSuccess, loadOrgDefaultSettingsSuccess);
	yield takeLatest(defaultSettingsActions.loadPersonDefaultSettingsSuccess, loadPersonDefaultSettingsSuccess);
	yield takeLatest(defaultSettingsActions.loadGroupSettings, loadGroupSettingsSaga);
}
